import React from 'react';
import styled from 'styled-components';

const StyledNav = styled.nav`
  background-color: #0F52BA;
  padding: 14px;
`;

const StyledHeading = styled.h1`
  color: white;
  margin: 0;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 100px;
  margin-left: 100px;
`;

const StyledTitle = styled.div`
  display: flex;
  align-items: center;

  h1 {
    font-size: 30px;
    font-weight: 600;
  }

  h6 {
    font-size: 12px;
    margin-left: 4px;
    font-weight: 300;
  }
`;

const StyledBox = styled.div`
  display: flex;
  align-items: center;
  color: black;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;

  i {
    font-size: 14px;
    margin-right: 5px;
  }

  h5 {
    margin: 0;
    font-size: 16px;
  }
`;

const Navbar: React.FC = () => {
  return (
    <StyledNav>
      <StyledHeading>
        <StyledHeader>
          <StyledTitle>
            <h1>MKS</h1>
            <h6>Sistemas</h6>
          </StyledTitle>
          <StyledBox>
          <i className="fa fa-shopping-cart"></i>
            <h5>0</h5>
          </StyledBox>
        </StyledHeader>
      </StyledHeading>
    </StyledNav>
  );
};

export default Navbar;